import React from 'react'

function TenderTextVAK() {
  return (
    <embed src="\pdfs\EAT1.5.6_VA-K_Conical_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextVAK